import React, { useMemo, useState } from 'react';
import axios from 'axios';
import useDetailFetch from '../../../../hooks/useDetailFetch';
import SingleItemDetailTemplate from '../../../Reusable_Components/SingleItemDetailTemplate';
import { useParams, useNavigate } from 'react-router-dom';
import { API_ROUTES, API_DOMAIN, headers } from '../../../Reusable_Components/Config/apiConfig';
import { ToastContext } from '../../../../context/ToastContext';
import ConfirmModal from '../../../Reusable_Components/ConfirmModal';

const SingleOpportunityPriorityDetails = () => {
  const { priorityId } = useParams();
  const decodedId = priorityId ? atob(priorityId) : priorityId;
  const id = decodedId.replace(/\D/g, '');
  const navigate = useNavigate();
  const { showToast } = React.useContext(ToastContext);

  const [showDelete, setShowDelete] = useState(false);

  const url = id ? `${API_DOMAIN}${API_ROUTES['opportunityPriority']}${id}/` : null;
  const { data: details, loading } = useDetailFetch(url);

  const columns = useMemo(() => {
    if (!details) return null;
    const excluded = ['id', 'created_at', 'updated_at'];
    return Object.keys(details)
      .filter(c => !excluded.includes(c))
      .map(c => ({ label: c.charAt(0).toUpperCase() + c.slice(1), field: c }));
  }, [details]);

  const handleDelete = async () => {
    try {
      await axios.delete(API_DOMAIN + API_ROUTES['opportunityPriority'] + id + '/', { headers });
      showToast('Priority deleted successfully', 'success');
      navigate('/opportunity/priority/list');
    } catch (error) {
      console.error('Error deleting Priority:', error);
      showToast('Failed to delete Priority', 'error');
    }
  };

  return (
    <div>
      <SingleItemDetailTemplate
        details={details}
        columns={columns}
        loading={loading}
        entityName="Priority"
        listPath="/opportunity/priority/list"
        editPath={`/opportunity/priority/input/${btoa(id)}`}
        onDelete={() => setShowDelete(true)}
      />
      <ConfirmModal
        isOpen={showDelete}
        onClose={() => setShowDelete(false)}
        onConfirm={handleDelete}
        title="Confirm Delete"
        message="Are you sure you want to delete this Priority?"
      />
    </div>
  );
};

export default SingleOpportunityPriorityDetails;
